<template>
  <div>
    <LoadingPanel :loading="loading" :loadingError="loadingError" />

    <div v-if="!loading" class="billing-product-list">
      <div class="billing-product-container">
        <div v-for="product of displayProductList" :key="product.id" class="billing-card-container" :style="cardContainerStyle">
          <BillingProductCard            
            :product="product"
            :productList="fullProductList"
            :purchaseButtonTitle="purchaseButtonTitle"
            :submitting="submittingPurchaseProductId == product.id"
            @purchaseClicked="$emit('purchaseClicked', $event)"
            @contactClicked="$emit('contactClicked', $event)"
          />
        </div>
      </div>
      <div v-if="displayProductList.length == 0" class="text-muted font-italic text-center">No products available</div>
    </div>
  </div>
</template>

<style scoped>
.billing-product-list {
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0px 15px 40px -20px rgba(0, 0, 0, 25%);
  border: 1px solid #f7f7f7;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  padding: 25px 0px;
}
.billing-product-container {
  display: flex;
  flex-direction: row;
  gap: 20px;
}
.billing-card-container:not(:last-child) {
  border-right: 1px solid #e7e7e7;
}
</style>


<script>
import BillingProductCard from '@/modules/admin/components/billingProductCard'
export default {
  name: 'BillingProductList',
  components: {
    BillingProductCard
  },
  props: {
    purchaseButtonTitle: {
      type: String,
      default: 'Checkout'
    },
    displayAddonProducts: Boolean,
    submittingPurchaseProductId: Number
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      fullProductList: [],
      displayProductList: [],
      billingData: {}
    }
  },
  computed: {
    cardContainerStyle() {
      if(this.displayProductList.length == 0)
        return {}

      let style = {
        width: Math.round((1.0 / this.displayProductList.length) * 100.0) + '%'
      }
      return style
    }
  },
  mounted() {
    this.requestData()
  },
  methods: {
    requestData() {
      this.loading = true
      this.loadingError = ''

      let dataRequestList = [
        this.$apiService.adminService.getBillingProducts()
      ]
      if(this.userHasReadPermission(this.PermissionTypes.AdminPermissionTypes.billing)) {
        dataRequestList.push(this.$apiService.adminService.getAccountBilling())
      }

      Promise.all(dataRequestList)
      .then(results => {
        // Only major products, don't show addons if not flagged
        this.fullProductList = results[0].data
        if(results[1])
          this.billingData = results[1].data

        this.displayProductList = this.fullProductList.filter(productInfo => {
          if(!!productInfo.isAddonProduct != !!this.displayAddonProducts)
            return false

          // If products require existing subscriptions to certain products, run the dependency check
          if(productInfo.requiresBillingProductId) {
            if(!this.hasSubscriptionProductId(productInfo.requiresBillingProductId))
              return false
          }

          return true
        })        
      })
      .catch(err => {
        this.loadingError = 'Error loading product info'
      })
      .finally(() => {
        this.loading = false
      })
    },
    hasSubscriptionProductId(billingProductId) {
      if(!this.billingData.subscriptionList)
        return false

      return this.billingData.subscriptionList.find(sub => {
        if(sub.subscriptionItems) {
          return sub.subscriptionItems.find(subItem => subItem.billingProductId == billingProductId) != null
        }
        return false
      }) != null
    }
  }
}
</script>